import {all, put, takeLatest} from 'redux-saga/effects';
import {handleAxiosException} from "./index";
import axios from "axios";


function* fetchRewardClaimOptions(action) {
    try {
        let response = yield axios.get(`/hotdeals/rest/rewards/${action.friendlyName}/claimOptions`);

        yield put({
            type: 'REWARD_CLAIM_OPTIONS_FETCHED',
            rewardClaimOptions: response.data
        })

    }catch(exception){
        if (exception && exception.response && exception.response.status === 404) {
            yield put({
                type: 'REWARD_CLAIM_OPTIONS_NOT_FOUND'
            })
        }else{
            handleAxiosException(exception);
        }
    }
}

export default function* rewardClaimOptionsSaga() {
    yield all([
        takeLatest(['FETCH_REWARD_CLAIM_OPTIONS', 'ACCOUNT_LIMIT_EXCEEDED'], fetchRewardClaimOptions)
    ]);
}